import { EventOptions } from '@amplitude/analytics-core'

import { amplitude } from '@/lib/amplitude'
import { INFRASTRUCTURE_ENVIRONMENT_TYPE } from '@/constants'

export const track = (
  event: string,
  properties?: Record<string, any>,
  eventOptions?: EventOptions,
) => {
  if (
    INFRASTRUCTURE_ENVIRONMENT_TYPE === 'prod' ||
    INFRASTRUCTURE_ENVIRONMENT_TYPE === 'stage'
  ) {
    amplitude.track(event, properties, eventOptions)
  }
}
